import React, { Suspense } from "react";
import DefaultModal from "../DefaultModal";
import ShowNewPasContent from "./ShowNewPasContent";
import LoaderContainer from "../../mui/loader_container/LoaderContainer";

export default function ShowNewPas({ isOpen, shownNewPas, closeModal }) {
  return (
    <DefaultModal
      isOpen={isOpen}
      miniModal
      closeModal={closeModal}
      classModal="show-new-pas__container">
      {isOpen ? (
        <Suspense fallback={<LoaderContainer center loader />}>
          <ShowNewPasContent closeModal={closeModal} shownNewPas={shownNewPas} />
        </Suspense>
      ) : (
        <LoaderContainer loader center />
      )}
    </DefaultModal>
  );
}
